export const INTAKE_WEIGHT_LABEL = "Gewicht";
export const INTAKE_WEIGHT_HINT = "Optional.";
export const INTAKE_WEIGHT_SUFFIX = "g";
/** 124 px, damit Pflegestelle (min. 150) und Gewicht bei 375/390 px in einer Zeile bleiben. */
export const INTAKE_WEIGHT_FIELD_WIDTH = 124;
export const INTAKE_SITE_MIN_WIDTH = 150;
export const INTAKE_KEPT_LINE = "Beibehalten: Pflegestelle · Funddatum · Art";
export const INTAKE_PLACE_HINT = "Optional. Kann später gesetzt werden.";
/**
 * Oberfläche kürzt hier. Die Spalte erlaubt 1–120 Zeichen
 * (animal_cases_species_free_text_len_chk in 20261014160000_organization_species.sql).
 * Die 119 sind die Auflage der A1-Nacharbeit. Ein technischer Grund für das
 * eine Zeichen weniger ist nicht belegt.
 */
export const SPECIES_FREE_TEXT_MAX = 119;
export const SPECIES_FREE_TEXT_TOO_LONG = "Die Art darf höchstens 119 Zeichen haben.";
/** Neutral, sobald das Feld die 119 Zeichen erreicht hat. Kein Fehler. */
export const SPECIES_FREE_TEXT_AT_MAX = "Maximal 119 Zeichen erreicht";
/** Paste über der Grenze. Das Feld behält die ersten 119 Zeichen. */
export const SPECIES_FREE_TEXT_TRUNCATED = "Auf 119 Zeichen gekürzt.";
export const FUND_DATE_CHECK_HINT = "Funddatum prüfen";
export const SPECIES_LIST_UNAVAILABLE =
  "Artenliste konnte nicht geladen werden. Andere Art bleibt möglich.";
export const SPECIES_LABEL = "Art";
export const SPECIES_REQUIRED = "Bitte Art wählen – „Unbekannt“ ist möglich.";
/** Fußzeile nach einem Versuch ohne Art. Der Satz im Feld bleibt der einzige Alert. */
export const SPECIES_CHECK_HINT = "Bitte die markierten Angaben prüfen.";
export const SPECIES_FREE_TEXT_HINT = "Freitext, wenn die Art nicht in der Liste steht.";
export const SPECIES_REQUIRED_ALERT_ID = "intake-species-required";
export const INTAKE_UNKNOWN_SPECIES_NAME = "Unbekannt";
export const INTAKE_UNKNOWN_SPECIES_CODE = "unknown";
/** Kein Katalog-Schlüssel. Beim Speichern wird daraus der Freitext „Unbekannt“. */
export const INTAKE_UNKNOWN_SPECIES_ID = "intake-unknown";
